export const COLORS = {
  ACCENT_200: '#fa9592',
  ACCENT_50: '#ffeaed',
  ACCENT_700: '#e1071a',
  ACCENT_900: '#c70000',
  BLACK: '#000',
  ERROR_50: '#ffebee',
  ERROR_700: '#d32f2f',
  INFO_50: '#e1f5fe',
  INFO_700: '#0288d1',
  NEUTRAL_200: '#efefef',
  NEUTRAL_400: '#bfbfbf',
  NEUTRAL_50: '#fafafa',
  NEUTRAL_600: '#777',
  NEUTRAL_800: '#444',
  SECONDARY_200: '#f9c57e',
  SECONDARY_50: '#fef1df',
  SECONDARY_600: '#ee8107',
  SECONDARY_800: '#e16207',
  SUCCESS_50: '#e3f4e4',
  SUCCESS_700: '#388e3c',
  WARNING_400: '#ffcd4c',
  WARNING_50: '#fff3d2',
  WHITE: '#fff',
}
